import React from "react";

import Script from "dangerous-html/react";

const ProcessSection: React.FC = () => (
  <section className="process-wrapper">
    <div className="process-container">
      <div className="process-header">
        <h2 className="section-title">Architectural Process</h2>
        <p className="section-subtitle">
          {" "}
          Systematic approach to delivering robust, scalable cloud solutions
          <span
            dangerouslySetInnerHTML={{
              __html: " ",
            }}
          />
        </p>
      </div>
      <div className="process-accordion">
        <details className="process-accordion-item">
          <summary className="process-accordion-summary">
            <div className="process-accordion-number">
              <span>01</span>
            </div>
            <div className="process-accordion-title-wrapper">
              <h3 className="process-accordion-title">
                Solution Design &amp; Discovery
              </h3>
              <p className="process-accordion-subtitle">
                {" "}
                Requirements analysis and architecture blueprint
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </p>
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              className="process-accordion-icon"
            >
              <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m9 18l6-6l-6-6"
              ></path>
            </svg>
          </summary>
          <div className="process-accordion-content">
            <p className="process-accordion-description">
              {" "}
              Comprehensive analysis of business requirements, technical
              constraints, and scalability goals. Define multi-tier architecture
              patterns, technology stack, and integration points. Create
              detailed system design documents and cloud infrastructure
              blueprints.
              <span
                dangerouslySetInnerHTML={{
                  __html: " ",
                }}
              />
            </p>
            <ul className="process-accordion-list">
              <li>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M20 6L9 17l-5-5"
                  ></path>
                </svg>
                <span>Stakeholder workshops and requirement gathering</span>
              </li>
              <li>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M20 6L9 17l-5-5"
                  ></path>
                </svg>
                <span>Cloud architecture blueprint with AWS services</span>
              </li>
              <li>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M20 6L9 17l-5-5"
                  ></path>
                </svg>
                <span>Microservices decomposition and API contracts</span>
              </li>
            </ul>
          </div>
        </details>
        <details className="process-accordion-item">
          <summary className="process-accordion-summary">
            <div className="process-accordion-number">
              <span>02</span>
            </div>
            <div className="process-accordion-title-wrapper">
              <h3 className="process-accordion-title">
                {" "}
                Security-by-Design Implementation
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </h3>
              <p className="process-accordion-subtitle">
                {" "}
                Comprehensive security protocols and compliance
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </p>
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              className="process-accordion-icon"
            >
              <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m9 18l6-6l-6-6"
              ></path>
            </svg>
          </summary>
          <div className="process-accordion-content">
            <p className="process-accordion-description">
              {" "}
              Integrate OAuth2, OIDC, SSL/TLS, and AWS Cognito for
              authentication and authorization. Implement encryption at rest and
              in transit, API security, and network isolation. Establish
              monitoring and threat detection systems.
              <span
                dangerouslySetInnerHTML={{
                  __html: " ",
                }}
              />
            </p>
            <ul className="process-accordion-list">
              <li>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M20 6L9 17l-5-5"
                  ></path>
                </svg>
                <span>OAuth2 and OIDC authentication flows</span>
              </li>
              <li>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M20 6L9 17l-5-5"
                  ></path>
                </svg>
                <span>AWS Cognito user management and federation</span>
              </li>
              <li>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M20 6L9 17l-5-5"
                  ></path>
                </svg>
                <span>OWASP Top 10 threat mitigation strategies</span>
              </li>
            </ul>
          </div>
        </details>
        <details className="process-accordion-item">
          <summary className="process-accordion-summary">
            <div className="process-accordion-number">
              <span>03</span>
            </div>
            <div className="process-accordion-title-wrapper">
              <h3 className="process-accordion-title">
                {" "}
                Resiliency &amp; High Availability Patterns
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </h3>
              <p className="process-accordion-subtitle">
                {" "}
                Fault tolerance and disaster recovery
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </p>
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              className="process-accordion-icon"
            >
              <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m9 18l6-6l-6-6"
              ></path>
            </svg>
          </summary>
          <div className="process-accordion-content">
            <p className="process-accordion-description">
              {" "}
              Design multi-region architectures with automated failover, circuit
              breakers, and retry mechanisms. Implement disaster recovery
              strategies with defined RTO and RPO metrics. Set up health checks,
              auto-scaling, and load balancing.
              <span
                dangerouslySetInnerHTML={{
                  __html: " ",
                }}
              />
            </p>
            <ul className="process-accordion-list">
              <li>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M20 6L9 17l-5-5"
                  ></path>
                </svg>
                <span>Multi-AZ and multi-region deployment strategies</span>
              </li>
              <li>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M20 6L9 17l-5-5"
                  ></path>
                </svg>
                <span>Circuit breaker and bulkhead patterns</span>
              </li>
              <li>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M20 6L9 17l-5-5"
                  ></path>
                </svg>
                <span>Automated backup and recovery procedures</span>
              </li>
            </ul>
          </div>
        </details>
        <details className="process-accordion-item">
          <summary className="process-accordion-summary">
            <div className="process-accordion-number">
              <span>04</span>
            </div>
            <div className="process-accordion-title-wrapper">
              <h3 className="process-accordion-title">
                {" "}
                Infrastructure as Code &amp; CI/CD
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </h3>
              <p className="process-accordion-subtitle">
                {" "}
                Automated provisioning and deployment
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </p>
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              className="process-accordion-icon"
            >
              <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m9 18l6-6l-6-6"
              ></path>
            </svg>
          </summary>
          <div className="process-accordion-content">
            <p className="process-accordion-description">
              {" "}
              Leverage AWS CDK and Terraform for infrastructure automation.
              Build CI/CD pipelines with Jenkins and GitLab CI for continuous
              integration and delivery. Implement blue-green deployments and
              canary releases.
              <span
                dangerouslySetInnerHTML={{
                  __html: " ",
                }}
              />
            </p>
            <ul className="process-accordion-list">
              <li>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M20 6L9 17l-5-5"
                  ></path>
                </svg>
                <span>AWS CDK and Terraform infrastructure code</span>
              </li>
              <li>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M20 6L9 17l-5-5"
                  ></path>
                </svg>
                <span>Jenkins and GitLab CI pipeline automation</span>
              </li>
              <li>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M20 6L9 17l-5-5"
                  ></path>
                </svg>
                <span>Zero-downtime deployment strategies</span>
              </li>
            </ul>
          </div>
        </details>
        <details className="process-accordion-item">
          <summary className="process-accordion-summary">
            <div className="process-accordion-number">
              <span>05</span>
            </div>
            <div className="process-accordion-title-wrapper">
              <h3 className="process-accordion-title">
                {" "}
                Monitoring &amp; Continuous Improvement
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </h3>
              <p className="process-accordion-subtitle">
                {" "}
                Observability and optimization
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </p>
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              className="process-accordion-icon"
            >
              <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m9 18l6-6l-6-6"
              ></path>
            </svg>
          </summary>
          <div className="process-accordion-content">
            <p className="process-accordion-description">
              {" "}
              Deploy comprehensive monitoring using Splunk, New Relic, Datadog,
              and AWS CloudWatch. Create dashboards with Quicksight and Power BI
              for data visualization. Establish alerting thresholds and incident
              response procedures.
              <span
                dangerouslySetInnerHTML={{
                  __html: " ",
                }}
              />
            </p>
            <ul className="process-accordion-list">
              <li>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M20 6L9 17l-5-5"
                  ></path>
                </svg>
                <span>Splunk, New Relic, and Datadog integration</span>
              </li>
              <li>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M20 6L9 17l-5-5"
                  ></path>
                </svg>
                <span>Quicksight and Power BI dashboards</span>
              </li>
              <li>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M20 6L9 17l-5-5"
                  ></path>
                </svg>
                <span>Performance optimization and cost management</span>
              </li>
            </ul>
          </div>
        </details>
      </div>
    </div>
  </section>
);

export default ProcessSection;
